


















import { Component, Vue } from "vue-property-decorator";
import { newsModule } from "@/store";
import type { FlickingOptions, Plugin, SelectEvent } from "@egjs/flicking";
import { AutoPlay, Pagination } from "@egjs/flicking-plugins";
import Loader from "@/components/ui/Loader.vue";
import { Article } from "@/store/news/article";

@Component({
  components: { Loader },
})
export default class DashboardNews extends Vue {
  autoplay = new AutoPlay({ duration: 6000, stopOnHover: true });
  pagination = new Pagination({ type: "bullet" });
  flicking: { options: Partial<FlickingOptions>; plugins: Plugin[] } = {
    options: {
      noPanelStyleOverride: true,
      align: "prev",
      circular: true,
    },
    plugins: [this.autoplay, this.pagination],
  };

  get loading(): boolean {
    return newsModule.fetching;
  }

  get articles(): Article[] {
    return newsModule.articles;
  }

  onArticleSelected({ index }: SelectEvent) {
    if (this.articles[index]) {
      window.open(this.articles[index].linkUrl, "_blank");
    }
  }

  async mounted(): Promise<void> {
    await this.fetch();
  }

  async fetch(): Promise<void> {
    try {
      await newsModule.fetch();
    } catch (e) {
      // TODO: display error
      console.log(e);
    }
  }
}
